<template>
    <div class="plan-preview col" :class="['radius' + Global.mockupConfig.radiusRatio, Global.mockupConfig.activeFont]">
        <div class="preview col">
            <h5 :style="{ color : Global.mockupConfig.colors.icons }">{{ plan.name || "Plan name" }}</h5>
            <p class="ft-bld txt-ctr">All our content, ad-free, offline, and in the background</p>
            <ul>
                <li>
                    <span class="ico" :style="{ background : Global.mockupConfig.colors.icons }">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <rect y="10.6067" width="3" height="10" transform="rotate(-45 0 10.6067)" fill="black"/>
                        <rect width="3" height="15" transform="matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)" fill="black"/>
                        </svg>
                    </span>
                    <span class="txt">+300 exclusive contents</span>
                </li>
                <li>
                    <span class="ico" :style="{ background : Global.mockupConfig.colors.icons }">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <rect y="10.6067" width="3" height="10" transform="rotate(-45 0 10.6067)" fill="black"/>
                        <rect width="3" height="15" transform="matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)" fill="black"/>
                        </svg>
                    </span>
                    <span class="txt">Ad-free & background play</span>
                </li>
                <li>
                    <span class="ico" :style="{ background : Global.mockupConfig.colors.icons }">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <rect y="10.6067" width="3" height="10" transform="rotate(-45 0 10.6067)" fill="black"/>
                        <rect width="3" height="15" transform="matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)" fill="black"/>
                        </svg>
                    </span>
                    <span class="txt">Downloads for offline viewing</span>
                </li>
            </ul>

            <div class="btn main n-pre" :style="{ background : Global.mockupConfig.colors.icons }">
                <span class="txt" v-if="plan.freeDays !== 0">Try {{ plan.freeDays }} day{{ plan.freeDays > 1 ? "s" : "" }} for free</span>
                <span class="txt" v-else>Subscribe</span>
            </div>

            <div class="price-tag ft-xbld" :style="{ color : Global.mockupConfig.colors.icons }">
                <span class="b">{{ displayPrice }}€</span>
                / {{ displayPriceType == "monthly" ? "month" : "year" }}
            </div>

            <span class="trial-cap">Billed automatically after trial</span>
        </div>

        <div class="switcher ft-xbld" v-show="plan.model == 'both'">
            <span :class="{ active : !isYearly }" :style="[ !isYearly ? { color : Global.mockupConfig.colors.icons } : '' ]" @click.prevent="changePricing">Monthly</span>
            <div class="switch" :class="{ tgld : isYearly }" @click.prevent="changePricing">
                <svg width="48" height="28" viewBox="0 0 70 40" fill="none">
                <rect class="bk-rect" opacity="0.15" width="70" height="40" rx="20" fill="white"/>
                <rect class="dot" x="4" y="4" width="32" height="32" rx="16" :fill="Global.mockupConfig.colors.icons"/>
                </svg>
            </div>
            <span :class="{ active : isYearly }" :style="[ isYearly ? { color : Global.mockupConfig.colors.icons } : '' ]" @click.prevent="changePricing">
                Yearly <br>({{ yearlyPercentOff }}% off)
            </span>
        </div>
    </div>
</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: "PlanCard",

        props: {
            plan: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                Global,
                isYearly: false
            }
        },

        computed: {

            displayPriceType() {
                switch (this.plan.model) {
                    case "monthly":
                        return "monthly"
                    case "annualy":
                        return "annualy"
                    default:
                        return this.isYearly ? "annualy" : "monthly"
                }
            },

            displayPrice() {
                let price = 0
                price = this.displayPriceType == "monthly" ? this.plan.monthlyPrice : this.plan.yearlyPrice
                return this.floatToPrice(this.priceToFloat(price))
            }, 

            yearlyPercentOff() {

                let monthPrice = this.priceToFloat(this.plan.monthlyPrice) * 12
                let yearPrice = this.priceToFloat(this.plan.yearlyPrice)
                
                if(!monthPrice || !yearPrice) {
                    return 0
                }
                
                if(monthPrice == 0 || yearPrice == 0) {
                    return 0
                }

                return (((monthPrice - yearPrice) / monthPrice) * 100).toFixed(0)
            }
        },

        methods: {

            changePricing() {
                this.isYearly = !this.isYearly
            },

            priceToFloat(price) {
                if(!price) return null
                if(typeof price !== "string") return price
                
                price = price.replace(/,/g, ".")
                price = price.replace(/[^1234567890.]+/g, "")
                return price === "" ? null : parseFloat(price)
            },

            floatToPrice(float) {
                if(float === null) return this.floatToPrice(0)
                return float.toFixed(2).replace(/\./g, ",")
            }
        }
    }
</script>